import styled from 'styled-components'

export const BrowseAllProductsContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`
